import { cx } from '@linaria/core';
import { memo, useCallback } from 'react';
import { goToRoom } from '../../../../actions/nav';
import { SettingsType } from '../../../../constants/enums';
import { getRecommendationPercentage } from '../../../../mfcLogic/recommendation';
import { getAnimationsEnabledfromUeopt } from '../../../../mfcLogic/settings';
import { trackAnalyticsEvent } from '../../../../utilities/analytics';
import { useModelColor } from '../../../Hooks/useModelColor';
import { useScreenStateSelector } from '../../../Hooks/useScreenState';
import { useSettingSelector } from '../../../Hooks/useSettings';
import { useUserSelector } from '../../../Hooks/useUser';
import PercentageBar from '../../../common/PercentageBar';
import APP_BREAKPOINTS from '../../../styles/breakpoints';
import PreviewPosterImage from '../../PreviewPosterImage';
import { modelNameStyles } from '../shared';
import "./Grid.linaria.module.css!=!./Grid?./Grid.linaria.module.css?css=H4sIAAAAAAAAA42OzRKCIBRG9z2Fm2ZqYQNqf7jpTRhSTBTBgBBjfPfGmqymFi3vd757z10R02DbYyj1WUbWdyw3JYIAzNNhthphFU+wIS78Luw1hsZ1zHKfM91y0qOCU/fERGGrbEbd5+THTpgzRTPDpEBKdtPBChteU8B9dlFaKtRKJgxV6TA7NDRnJFi8PgmSLWjd0t83xSk5xhsMi84JS/+LfCGFCTW7UgSj1qXDbwt4WbbrpNwVGOq6JJX8L3q3wIflBja6n+57AQAA"
const nameStyles = "atm_vy_1osqo2v";
const rootStyles = "atm_vy_1osqo2v atm_j3_1osqo2v";
const containerStyles = "atm_9s_1txwivl atm_ar_vrvcex atm_9j_tlke0l";
const responsiveNameStyles = "atm_ng4b36_1fwxnve atm_754h8f_1skhajo";
interface GridProps {
  id: number;
  recommendation: number;
  inRoomOrProfile?: boolean;
}
const Grid = (props: GridProps) => {
  const {
    id,
    recommendation,
    inRoomOrProfile
  } = props;
  const matchPercentage: number = getRecommendationPercentage(recommendation);
  const [animatePreviews] = useSettingSelector(SettingsType.DEFAULT, 'animatePreviews');
  const staticImage = !getAnimationsEnabledfromUeopt(animatePreviews);
  const color = useUserSelector(id, 'color');
  const name = useUserSelector(id, 'name');
  const slug = useUserSelector(id, 'slug');
  const windowWidth = useScreenStateSelector('windowWidth');
  const reducedSize = windowWidth <= APP_BREAKPOINTS.s;
  const modelColor = useModelColor(color);
  const displayName = name || slug;
  const onClickOpenRoom = useCallback(() => {
    trackAnalyticsEvent({
      action: `ModelsYouMayLike__ClickThrough`,
      data: {
        clickedFromPoster: true
      }
    });
    goToRoom(slug);
  }, [slug, inRoomOrProfile]);
  if (!name) {
    return null;
  }
  return <section key={id} data-testid="ModelsYouMayLike__PosterItem" className={rootStyles}>
            <article className={containerStyles}>
                <div>
                    <div>
                        <div className={nameStyles}>
                            <span style={{
              color: modelColor
            }} className={cx(modelNameStyles, responsiveNameStyles)}>
                                {displayName}
                            </span>
                        </div>
                    </div>
                    <PreviewPosterImage onClick={onClickOpenRoom} id={id} height={!reducedSize ? 81.5625 : 61.171875} width={!reducedSize ? 145 : 108.75} staticImage={staticImage} rounded />
                    <PercentageBar percentage={matchPercentage} color={modelColor} />
                </div>
            </article>
        </section>;
};
export default memo(Grid);